import { api_url } from "../../../utils";

const Macrozonas = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=macrozonas_10&schema_city=",
    zindex: 2,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    macrozonas: "Número de la macrozona: ",
                    nombre: "Nombre de la macrozona: ",
                    poblacion_: "Población de la macrozona 2024: ",
                },
            },
            separators: {
                decimal: [],
                thousand: ["poblacion_"],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Macrozonas",
    style: {
        regular: false,
        fillColor: "rgba(255, 255, 255, 0)",
        strokeColor: "rgb(185, 56, 59)",
        strokeWidth: 1.4,
        strokeLineDash: [2, 4],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Macrozonas.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass:
                "map-legend-symbol-border-2-5-px-red-185-56-59",
            class: [
                {
                    fillColor: "rgba(0, 0, 0, 0)",
                    strokeColor: "rgb(185, 56, 59)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.Macrozonas.classes.1",
                },
            ],
        },
    },
};

export default Macrozonas;
